import { Injectable } from '@odinjs/odin';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';

import { GeneratedOsRoutesAPI } from '../constants';
import { ChartFilter } from '../interfaces';

@Injectable({})
export class GeneratedOsService {

  static total(filter: ChartFilter | undefined): Promise<string> {
    return HttpService.get(GeneratedOsRoutesAPI.GENERATED_OS_TOTAL, filter)
      .then(response => {
        return response.body as string;
      });
  }

}
